import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Модная поло-рубашка высокого качества от бельгийской компании Stanley&amp;Stella. Каждая деталь продумана и сделана с умом: фасон, особое плетение ткани «пике», узкий воротник на пуговицах, геометричные вырезы по бокам. Высокая плотность хлопка (220 гр/м<sup>2</sup>) и европейская технология окрашивания исключают потерю формы и выцветание красок даже при самой частой носке: поло долго будет выглядеть, как новая, даже если вы будете носить ее каждый день на работу или надевать для занятий спортом. 95% состава ткани — это высококачественный индийский хлопок, оставшиеся 5% — эластан, который придает ткани дополнительную гладкость и мягкость.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`polo_shirt`],
      sizeInfo: `polo_shirt`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
